import ads from './ads'
import OneSignal from "./one-signal"

const domEvents = {};

/**
 * Specific method to listen scroll only once
 *
 */
const oneUseScrollEvents = () => {
    initialize();
    // Remove listener for one use purpose
    document.removeEventListener('scroll', oneUseScrollEvents)
};

const initialize = () => {
    if ((document.readyState === 'complete' || document.readyState === 'interactive')  && window.pageYOffset >= 0 ) {
        new OneSignal();
    }
}

/**
 * Bind dom events here
 */
const bindEvents = () => {
    ads.init();
    document.addEventListener('scroll', oneUseScrollEvents)
};

domEvents.init = () => {
    bindEvents();
};

export default domEvents